import Vue from 'vue'
import App from './App'
import router from './router'
import elementUi from 'src/common/element-ui'
import VeeValidate from 'src/common/validator'
import http from 'src/common/http'
import store from 'src/vuex/store'
import VueClipboard from 'vue-clipboard2'
import '@/assets/css/manage.css'
import '@/assets/css/font.css'
import '@/assets/css/main.css'
import '@/assets/css/style.css'
import HappyScroll from 'vue-happy-scroll'
// 引入css
import 'vue-happy-scroll/docs/happy-scroll.css'
Vue.use(HappyScroll)
Vue.use(VueClipboard) /* 剪贴板 */

import'../../node_modules/echarts/map/js/world.js'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(http)
VeeValidate()
elementUi()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data:{
    Hub:new Vue()
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/jvsit/main.js